/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Meta_DescriptionInputs */

const en_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drills and tips between lessons from Mark Egly Golf.`)
};

const es_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicios y consejos entre lecciones de Mark Egly Golf.`)
};

const de_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen und Tipps für die Zeit zwischen den Golfstunden – von Mark Egly Golf.`)
};

const zh_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf 课程间隙的练习和技巧。`)
};

const ar_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمارين ونصائح بين الدروس من Mark Egly Golf.`)
};

const fr_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercices et conseils entre les cours de Mark Egly Golf.`)
};

const vi_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài tập và mẹo giữa các buổi học từ Mark Egly Golf.`)
};

const sw_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mazoezi na vidokezo kati ya masomo kutoka kwa Mark Egly Golf.`)
};

const th_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การฝึกซ้อมและเคล็ดลับระหว่างบทเรียนจาก Mark Egly Golf`)
};

const bs_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbe i savjeti između lekcija od Mark Egly Golf.`)
};

const ja_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golfによる、レッスンの合間に取り組めるドリルとヒント。`)
};

const ko_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf의 레슨 사이에 할 수 있는 드릴과 팁.`)
};

const pt_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios e dicas para praticar entre as aulas, da Mark Egly Golf.`)
};

const it_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizi e consigli tra una lezione e l'altra da Mark Egly Golf.`)
};

const sv_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Övningar och tips mellan lektionerna från Mark Egly Golf.`)
};

const nl_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefeningen en tips tussen de lessen door van Mark Egly Golf.`)
};

const da_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øvelser og tips mellem lektionerne fra Mark Egly Golf.`)
};

const nb_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øvelser og tips mellom timene fra Mark Egly Golf.`)
};

const fi_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golfin harjoitteita ja vinkkejä tuntien väliin.`)
};

const pl_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenia i wskazówki na czas między lekcjami od Mark Egly Golf.`)
};

const ru_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Упражнения и советы между уроками от Mark Egly Golf.`)
};

const tr_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf'ten dersler arası alıştırmalar ve ipuçları.`)
};

const hi_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf की ओर से पाठों के बीच के लिए ड्रिल और सुझाव।`)
};

const id_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan dan tips di sela pelajaran dari Mark Egly Golf.`)
};

const ms_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latih tubi dan petua antara pelajaran daripada Mark Egly Golf.`)
};

const cs_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cvičení a tipy mezi lekcemi od Mark Egly Golf.`)
};

const el_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ασκήσεις και συμβουλές ανάμεσα στα μαθήματα από το Mark Egly Golf.`)
};

const he_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תרגילים וטיפים בין השיעורים מ-Mark Egly Golf.`)
};

const af_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefeninge en wenke tussen lesse van Mark Egly Golf.`)
};

const hu_practice_meta_description = /** @type {(inputs: Practice_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gyakorlatok és tippek az órák közötti időre a Mark Egly Golftól.`)
};

/**
* | output |
* | --- |
* | "Drills and tips between lessons from Mark Egly Golf." |
*
* @param {Practice_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const practice_meta_description = /** @type {((inputs?: Practice_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_practice_meta_description(inputs)
	if (locale === "de") return de_practice_meta_description(inputs)
	if (locale === "zh") return zh_practice_meta_description(inputs)
	if (locale === "ar") return ar_practice_meta_description(inputs)
	if (locale === "fr") return fr_practice_meta_description(inputs)
	if (locale === "vi") return vi_practice_meta_description(inputs)
	if (locale === "sw") return sw_practice_meta_description(inputs)
	if (locale === "th") return th_practice_meta_description(inputs)
	if (locale === "bs") return bs_practice_meta_description(inputs)
	if (locale === "ja") return ja_practice_meta_description(inputs)
	if (locale === "ko") return ko_practice_meta_description(inputs)
	if (locale === "pt") return pt_practice_meta_description(inputs)
	if (locale === "it") return it_practice_meta_description(inputs)
	if (locale === "sv") return sv_practice_meta_description(inputs)
	if (locale === "nl") return nl_practice_meta_description(inputs)
	if (locale === "da") return da_practice_meta_description(inputs)
	if (locale === "nb") return nb_practice_meta_description(inputs)
	if (locale === "fi") return fi_practice_meta_description(inputs)
	if (locale === "pl") return pl_practice_meta_description(inputs)
	if (locale === "ru") return ru_practice_meta_description(inputs)
	if (locale === "tr") return tr_practice_meta_description(inputs)
	if (locale === "hi") return hi_practice_meta_description(inputs)
	if (locale === "id") return id_practice_meta_description(inputs)
	if (locale === "ms") return ms_practice_meta_description(inputs)
	if (locale === "cs") return cs_practice_meta_description(inputs)
	if (locale === "el") return el_practice_meta_description(inputs)
	if (locale === "he") return he_practice_meta_description(inputs)
	if (locale === "af") return af_practice_meta_description(inputs)
	if (locale === "hu") return hu_practice_meta_description(inputs)
	return en_practice_meta_description(inputs)
});